const React            = require("react");

const DataActionUtil  = require("../../../util/DataActionUtil.js");
const ObservableUtil = require('../../../util/ObservableUtil.js');
const UploadFileButton = require("../generic/UploadFileButton.jsx");


class BulkUploadModelsButton extends React.Component {

  constructor() {
    super()

    this.onUpload = this.onUpload.bind(this)

    this.state = {
      packages: []
    }
  }

  componentDidMount () {
    ObservableUtil.subscribeToChange("libraryPackages", this.props.resource.id, "BulkUploadModelsButton", libraryPackages => this.onLibraryPackages(libraryPackages))
  }

  componentWillUnmount () {
    ObservableUtil.unsubscribeToChange("libraryPackages", this.props.resource.id, "BulkUploadModelsButton");
  }

  onLibraryPackages (libraryPackages) {
    this.setState({ packages: libraryPackages });
  }

  async onUpload (files) {
    const { setLoading, resource, hub, handleError } = this.props;
    const isPrivate = resource.private || false;

    try {
      const packageNames = this.state.packages.map(pkg => pkg.name);
      const models3d = await DataActionUtil.bulkUpload3dModels(handleError, files, packageNames, hub.id, isPrivate, setLoading);
      await DataActionUtil.attach3dModelToPackagesInLibrary(handleError, { id: resource.id, name: resource.name }, models3d, setLoading);
      return this.props.history.go(this.props.location.pathname);
    } catch (err) {
      if (err.message) {
        handleError(null, 'bulk upload files', err.message);
      } else {
        handleError(null, 'bulk upload files', 'An error occurred while uploading the files.');
      }
    }
  }

  render() {
    const { packages } = this.state;
    const { current_user_id, resource } = this.props;
    const { user_id, permissions } = resource;

    const shouldRender = current_user_id === user_id && permissions.includes("publish resource");

    return ( shouldRender && <UploadFileButton
      multiple
      accept=".step, .stp , .f3d"
      onUpload={this.onUpload}
      text="Attach 3D Models"
      addedClass="blue responsible-library-info"
      disabled={packages.length === 0}
    />)
  }
}

module.exports = BulkUploadModelsButton;
